import { useTranslate } from '@tolgee/react';
import ModalBody from '../../../components/modals/modalBody';
import { AIprofileSettings } from '../../../components/lomavisCreator/components/ai-assistant/profileSettings';
import { useSelector } from 'react-redux';
import { dispatch } from '../../../redux/store';
import {
  saveAiAssistantProfile,
  setShowAiAssistant,
  updateAiAssistantUiAttribute,
  updateUseSeparateTextFields
} from '../../../redux/slices/lomavisCreator/lomavisCreator';
import { AiConversationColumn } from '../../../components/lomavisCreator/components/ai-assistant/aiConversationColumn';
import { QuickActions } from '../../../components/lomavisCreator/components/ai-assistant/quickActions';
import { StartSettings } from '../../../components/lomavisCreator/components/ai-assistant/startSettings';
import { useEffect } from 'react';
import { ConfirmationModal } from '../../../components/lomavisCreator/components/confirmationModal';
import { ALL } from '../../../config/constants';
import toast from 'react-hot-toast';
import { OwnIdentityModal } from '../../../components/lomavisCreator/components/ai-assistant/ownIdentityModal';
import { textIsUrl } from '../../../components/lomavisCreator/config/buttonsValidatorsFunctions';
import { fields } from '../../../components/lomavisCreator/components/ai-assistant/constants';

export const AIassistantModal: React.FC<any> = (props) => {
  const { t } = useTranslate();
  const {
    quillEditors,

    aiAssistant: {
      ui: {
        showProfileSettings,
        showStartSettings,
        showQuickActions,
        showUseTextConfirmation
      },
      profile,
      conversation: { count, isInitiated, pendingUseText }
    }
  } = useSelector((state: any) => state.lomavisCreator);
  const handleSave = (): any => {
    const urlIsValid = profile.homepage ? textIsUrl(profile.homepage) : true;

    if (!urlIsValid) {
      toast.error(t('lomavisCreator.aiAssistant.profileSettings.invalidUrl'), {
        duration: 2000,
        position: 'top-right'
      });
      return;
    }

    // check fields for max length
    const invalidFields = fields.filter(
      (field) => field.maxLength && profile[field.id]?.length > field.maxLength
    );
    if (invalidFields.length > 0) {
      toast.error(
        t('lomavisCreator.aiAssistant.profileSettings.invalidLength', {
          fields: invalidFields.map((field) => t(field.label)).join(', ')
        }),
        {
          duration: 2000,
          position: 'top-right'
        }
      );
      return;
    }
    dispatch(
      saveAiAssistantProfile(() => {
        // show toaster
        toast.success(t('lomavisCreator.aiAssistant.profileSaved'), {
          duration: 2000,
          position: 'top-right'
        });
        dispatch(
          updateAiAssistantUiAttribute({
            attribute: 'showProfileSettings',
            value: false
          })
        );
      }) as any
    );
  };
  useEffect(() => {
    if (!isInitiated) return;
    if (count > 0) {
      dispatch(
        updateAiAssistantUiAttribute({
          attribute: 'showQuickActions',
          value: true
        })
      );
      dispatch(
        updateAiAssistantUiAttribute({
          attribute: 'showStartSettings',
          value: false
        })
      );
    }

    if (count === 0) {
      dispatch(
        updateAiAssistantUiAttribute({
          attribute: 'showStartSettings',
          value: true
        })
      );
      dispatch(
        updateAiAssistantUiAttribute({
          attribute: 'showQuickActions',
          value: false
        })
      );
    }
  }, [count, isInitiated]);
  return (
    <ModalBody onClose={() => dispatch(setShowAiAssistant(false))}>
      {/* Header Row */}
      <div className="h-100 d-flex flex-column ">
        <OwnIdentityModal />
        {
          <ConfirmationModal
            title={t('lomavisCreator.aiAssistant.useText')}
            body={t('lomavisCreator.aiAssistant.useTextConfirmation')}
            primaryText={t('lomavisCreator.aiAssistant.yes')}
            secondaryText={t('lomavisCreator.aiAssistant.no')}
            show={showUseTextConfirmation}
            handleClose={() =>
              dispatch(
                updateAiAssistantUiAttribute({
                  attribute: 'showUseTextConfirmation',
                  value: false
                })
              )
            }
            handlePrimary={() => {
              const editor = quillEditors[pendingUseText?.platform] || null;
              if (pendingUseText?.platform !== ALL) {
                dispatch(updateUseSeparateTextFields(true));
              }

              if (editor) {
                const text = editor.setText(pendingUseText?.response, 'user');
              }
              dispatch(
                updateUseSeparateTextFields(pendingUseText?.platform !== ALL)
              );
              toast.success(t('lomavisCreator.aiAssistant.textUsed'), {
                position: 'top-right'
              });
              dispatch(
                updateAiAssistantUiAttribute({
                  attribute: 'showUseTextConfirmation',
                  value: false
                })
              );
            }}
            handleSecondary={() =>
              dispatch(
                updateAiAssistantUiAttribute({
                  attribute: 'showUseTextConfirmation',
                  value: false
                })
              )
            }
          />
        }

        <div className="row mb-5">
          <div className="col-12">
            <div className="card d-flex justify-content-between flex-row align-items-center p-4">
              <h2>{t('lomavisCreator.aiAssistant.aiAssistant')}</h2>

              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={() => {
                  dispatch(
                    updateAiAssistantUiAttribute({
                      attribute: 'showProfileSettings',
                      value: true
                    })
                  );
                }}
              >
                {' '}
                <i className="fa-solid fa-gear cursor-pointer"></i>
                {t('lomavisCreator.aiAssistant.settings')}
              </button>
            </div>
          </div>
        </div>

        <div
          className={
            !showProfileSettings
              ? 'row h-100'
              : ' row d-flex flex-column flex-grow-1 overflow-auto'
          }
        >
          {!showProfileSettings && (
            <>
              <div
                className="col-9 overflow-hidden"
                style={{ maxHeight: 'calc(100vh - 100px)' }}
              >
                <AiConversationColumn />
              </div>

              <div className="col-3">
                {isInitiated && showStartSettings && <StartSettings />}
                {isInitiated && showQuickActions && <QuickActions />}
                {!isInitiated && (
                  <div className="card p-4 h-100">
                    <h4 className="w-100 text-center">
                      {t('lomavisCreator.aiAssistant.startSettings')}
                    </h4>
                  </div>
                )}
              </div>
            </>
          )}
          {showProfileSettings && <AIprofileSettings />}
        </div>
        {/* buttons bar for AI profile settings */}
        {showProfileSettings && (
          <div className=" mt-2 p-4 card">
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={() =>
                  dispatch(
                    updateAiAssistantUiAttribute({
                      attribute: 'showProfileSettings',
                      value: false
                    })
                  )
                }
              >
                {t('lomavisCreator.aiAssistant.cancel')}
              </button>
              <div className="m-2"></div>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={handleSave}
              >
                {t('lomavisCreator.aiAssistant.save')}
              </button>
            </div>
          </div>
        )}
      </div>
    </ModalBody>
  );
};
